import React from 'react';
import './button.scss';
export var CustomButton = function (props) {
    var label = props.label, onClick = props.onClick, className = props.className, disabled = props.disabled;
    return (React.createElement("div", { className: "btn-custom " + className },
        React.createElement("button", { type: "button", className: "btn btn-default-custom", disabled: disabled ? true : false, onClick: function () { return onClick(); } }, label)));
};
